<div *ngIf='!submitted else resultTpl'>
  <h1 class="set-title">Set a New Password</h1>

  <!-- Error Display Component -->
  <div class="mb-4">
    <app-error-display
      *ngIf="showError()"
      [error]="errorDetails"
      [showRetry]="true"
      (retry)="onRetry()"
      (dismiss)="onDismissError()"
    >
    </app-error-display>
  </div>

  <form #setPasswordForm [formGroup]='form' (ngSubmit)='login()' class="set-form">
    <label class="block">
      <span class="block mb-1 text-sm font-medium set-label">New Password</span>
      <div class="relative">
        <input
          nz-input
          autocomplete="new-password"
          formControlName='password'
          name="password"
          class="form-input input input-bordered input-md rounded-lg w-full pr-24"
          [type]="isPasswordVisible() ? 'text' : 'password'"
          required
          [disabled]="isSubmitting"
          aria-label="New Password"
        />
        <button
          type="button"
          tabindex="-1"
          class="btn btn-ghost btn-xs absolute right-2 top-1/2 -translate-y-1/2"
          (click)="isPasswordVisible.set(!isPasswordVisible())"
          aria-label="Toggle password visibility"
        >
          {{ isPasswordVisible() ? 'Hide' : 'Show' }}
        </button>
      </div>
    </label>

    <label class="block">
      <span class="block mb-1 text-sm font-medium set-label">Confirm new password</span>
      <div class="relative">
        <input
          nz-input
          autocomplete="new-password"
          formControlName='password_confirm'
          name="password_confirm"
          class="form-input input input-bordered input-md rounded-lg w-full pr-24"
          [type]="isPasswordConfirmVisible() ? 'text' : 'password'"
          required
          [disabled]="isSubmitting"
          aria-label="Confirm new password"
        />
        <button
          type="button"
          tabindex="-1"
          class="btn btn-ghost btn-xs absolute right-2 top-1/2 -translate-y-1/2"
          (click)="isPasswordConfirmVisible.set(!isPasswordConfirmVisible())"
          aria-label="Toggle confirm password visibility"
        >
          {{ isPasswordConfirmVisible() ? 'Hide' : 'Show' }}
        </button>
      </div>
    </label>

    <button
      type='submit'
      [disabled]="isSubmitting"
      class="w-full btn btn-primary btn-md lg:btn-lg set-submit"
      [class.loading]="isSubmitting"
    >
      {{ isSubmitting ? 'Resetting...' : 'Reset my Password' }}
      <span class='fe fe-arrow-right' *ngIf="!isSubmitting"></span>
    </button>
    <button
      type="button"
      routerLink='/passport/login'
      class="btn btn-ghost btn-md w-full mt-1"
      [disabled]="isSubmitting"
    >
      Back to Login
    </button>
  </form>
</div>

<ng-template #resultTpl>
  <nz-result
    nzStatus="success"
    nzTitle="Your password has been changed!"
    nzSubTitle="You can now log in with your new password"
  >
    <div nz-result-extra>
      <div class="flex justify-center my-3">
        <button class='btn btn-primary' routerLink='/passport/login'>Back to Login</button>
      </div>
    </div>
  </nz-result>
</ng-template>
